/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_Client_ThreeInputs */

const en_features_sample_client_three = /** @type {(inputs: Features_Sample_Client_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna Brooks`)
};

const pl_features_sample_client_three = /** @type {(inputs: Features_Sample_Client_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna Kowal`)
};

/**
* | output |
* | --- |
* | "Anna Brooks" |
*
* @param {Features_Sample_Client_ThreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_client_three = /** @type {((inputs?: Features_Sample_Client_ThreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_Client_ThreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_client_three(inputs)
	return en_features_sample_client_three(inputs)
});